import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { stripSchemeAndPort } from "./urlParser";

window.Pusher = Pusher;

function initializeEcho() {
    if (!window.PUSHER_APP_CONFIG) {
        console.warn('Missing Pusher configuration for Laravel Echo. Please ensure PUSHER_APP_CONFIG is set on the window object.');
        return;
    }
    const config = window.PUSHER_APP_CONFIG;

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: config.pusherKey,
        cluster: config.pusherCluster ?? 'mt1',
        wsHost: stripSchemeAndPort(config.pusherHost),
        wsPort: config.pusherPort,
        wssPort: config.pusherPort,
        forceTLS: config.pusherForceTLS,
        encrypted: true,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeEcho);
} else {
    initializeEcho();
}
